import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { Modal, Form, Input, Button, Divider, Select, DatePicker, Radio, Switch } from 'antd';
import { useQuery, useMutation } from 'react-query';
import rootApi from '@utils/baseAPI/WrapperApi';
import get from 'lodash/get';
import { showError, showSuccess } from '@components/notification';
import * as yup from 'yup';
import { apiAddUserOperator } from '@services/ManageUserOperator/UserOperatorServices';
import { apiGetAllRoles } from '@services/ManageRoles/RoleServices';
import { usePermission } from '@contexts/Auth/UsePermission';
import BranchSelectMultiple from '@components/FilterAdvance/components/SelectBranchMultiple';
import ManageGroupSelect from '@components/FilterAdvance/components/SelectManageGroup';
const { Option } = Select;

export const role_options = [
  { label: 'Kỹ thuật viên', value: 0 },
  { label: 'Kỹ sư', value: 1 },
  { label: 'Quản lý', value: 2 },
  { label: 'Quản trị viên', value: 101915236 }
];

function RequestDialogModel({ open, onClose }) {
  const [isLoading, setIsLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const { isSuperAdmin } = usePermission();

  // Fetch roles when component mounts
  useEffect(() => {
    if (open) {
      fetchRoles();
    }
  }, [open]);

  const fetchRoles = async () => {
    try {
      const response = await apiGetAllRoles();
      let roleData = response?.data?.data || [];

      // Chỉ SUPER_ADMIN mới có thể tạo user với role SUPER_ADMIN
      if (!isSuperAdmin) {
        roleData = roleData.filter((role) => role.name !== 'SUPER_ADMIN');
      }

      setRoles(roleData);
    } catch (error) {
      console.error('Error fetching roles:', error);
      showError('Có lỗi xảy ra khi tải danh sách vai trò');
    }
  };

  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
      confirmPassword: '',
      role_ids: undefined,
      is_company_user: false,
      branch_code: [],
      zone_code: []
    },
    validationSchema: yup.object({
      username: yup.string().required().label('Tên đăng nhập'),
      password: yup
        .string()
        .required('Mật khẩu là bắt buộc')
        .min(8, 'Mật khẩu phải có ít nhất 8 ký tự')
        .matches(/[a-zA-Z]/, 'Mật khẩu phải chứa ít nhất một chữ cái')
        .matches(/[0-9]/, 'Mật khẩu phải chứa ít nhất một chữ số')
        .matches(/[@$!%*?&#]/, 'Mật khẩu phải chứa ít nhất một ký tự đặc biệt')
        .label('Mật khẩu'),
      confirmPassword: yup
        .string()
        .required('Nhập lại mật khẩu là bắt buộc')
        .oneOf([yup.ref('password'), null], 'Mật khẩu nhập lại không khớp')
        .label('Nhập lại mật khẩu'),
      role_ids: yup.mixed().required('Vui lòng chọn vai trò').label('Vai trò'),
      branch_code: yup.array().when('is_company_user', {
        is: false,
        then: (schema) =>
          schema.min(1, 'Vui lòng chọn ít nhất một chi nhánh').required('Vui lòng chọn chi nhánh'),
        otherwise: (schema) => schema.notRequired()
      }),
      zone_code: yup.array().notRequired()
    }),
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        const payload = {
          user_name: get(values, 'username'),
          password: get(values, 'password'),
          full_name: get(values, 'username'),
          role_ids: [get(values, 'role_ids')],
          is_company_user: get(values, 'is_company_user')
        };

        // Chỉ gửi branch/group data nếu KHÔNG phải company user
        if (!values.is_company_user) {
          payload.zone_code = get(values, 'zone_code') || [];
        }

        const res = await apiAddUserOperator(payload);
        onClose();
        showSuccess({ message: 'Tạo người dùng thành công' });
        formik.resetForm();
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    }
  });

  return (
    <div>
      <Modal
        title="Tạo mới người dùng"
        visible={open}
        onCancel={onClose}
        footer={[
          <Button key="back" style={{ height: '36px' }} onClick={onClose}>
            Hủy
          </Button>,
          <Button
            key="submit"
            style={{ backgroundColor: '#00904A', color: '#FFFF', height: '36px' }}
            loading={isLoading}
            onClick={formik.handleSubmit}>
            Tạo mới
          </Button>
        ]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <span>
                Tên đăng nhập <span style={{ color: 'red' }}>*</span>
              </span>
            }
            validateStatus={formik.errors.username ? 'error' : ''}
            style={{ marginBottom: 10 }}
            help={formik.errors.username}>
            <Input
              name="username"
              value={formik.values.username}
              onChange={formik.handleChange}
              style={{ height: '36px' }}
            />
          </Form.Item>
          {/* <Form.Item
            label={
              <span>
                Số điện thoại <span style={{ color: 'red' }}>*</span>
              </span>
            }
            validateStatus={formik.errors.phoneNumber ? 'error' : ''}
            style={{ marginBottom: 10 }}
            help={formik.errors.phoneNumber}>
            <Input
              name="phoneNumber"
              value={formik.values.phoneNumber}
              onChange={formik.handleChange}
              style={{ height: '36px' }}
            />
          </Form.Item>
          <Form.Item
            label={
              <span>
                Email <span style={{ color: 'red' }}>*</span>
              </span>
            }
            validateStatus={formik.errors.email ? 'error' : ''}
            style={{ marginBottom: 10 }}
            help={formik.errors.email}>
            <Input
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              style={{ height: '36px' }}
            />
          </Form.Item> */}
          <Form.Item
            label={
              <span>
                Mật khẩu <span style={{ color: 'red' }}>*</span>
              </span>
            }
            validateStatus={formik.errors.password ? 'error' : ''}
            style={{ marginBottom: 10 }}
            help={formik.errors.password}>
            <Input.Password
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              style={{ height: '36px' }}
            />
          </Form.Item>
          <Form.Item
            label={
              <span>
                Nhập lại mật khẩu <span style={{ color: 'red' }}>*</span>
              </span>
            }
            validateStatus={formik.errors.confirmPassword ? 'error' : ''}
            style={{ marginBottom: 10 }}
            help={formik.errors.confirmPassword}>
            <Input.Password
              name="confirmPassword"
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              style={{ height: '36px' }}
            />
          </Form.Item>
          <Form.Item
            label={
              <span>
                Vai trò <span style={{ color: 'red' }}>*</span>
              </span>
            }
            validateStatus={formik.errors.role_ids ? 'error' : ''}
            style={{ marginBottom: 10 }}
            help={formik.errors.role_ids}>
            <Select
              name="role_ids"
              value={formik.values.role_ids}
              style={{ height: '36px' }}
              placeholder="Chọn vai trò cho người dùng"
              onChange={(value) => formik.setFieldValue('role_ids', value)}>
              {roles.map((role) => (
                <Option key={role.id} value={role.id}>
                  {role.name} - {role.descriptions || 'Không có mô tả'}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Divider>Vùng quản lý</Divider>

          <Form.Item label="Tài khoản cấp công ty" style={{ marginBottom: 10 }}>
            <Switch
              checked={formik.values.is_company_user}
              onChange={(checked) => {
                formik.setFieldValue('is_company_user', checked);
                // Clear branch and group when turning ON company user (không cần nhập khi là tài khoản công ty)
                if (checked) {
                  formik.setFieldValue('branch_code', []);
                  formik.setFieldValue('zone_code', []);
                }
              }}
              checkedChildren="Có"
              unCheckedChildren="Không"
            />
          </Form.Item>

          {!formik.values.is_company_user && (
            <>
              <Form.Item
                label="Khu vực quản lý"
                style={{ marginBottom: 10 }}
                validateStatus={formik.errors.zone_code && formik.touched.zone_code ? 'error' : ''}
                help={formik.touched.zone_code && formik.errors.zone_code}>
                <ManageGroupSelect
                  key={JSON.stringify(formik.values.zone_code)}
                  value={formik.values.zone_code}
                  onChange={(values) => {
                    formik.setFieldValue('zone_code', values);
                    formik.setFieldTouched('zone_code', true);
                  }}
                  showTitle={false}
                />
              </Form.Item>
            </>
          )}
        </Form>
      </Modal>
    </div>
  );
}

export default RequestDialogModel;
